module.exports = __webpack_public_path__ + "static/productInfoSide.25046ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/productInfoSide.jpg
// module id = 849
// module chunks = 82539731189068